module.exports = __webpack_public_path__ + "console/img/machinecore_logo_final@2x.efbf5833.png";